
(function(){
  "use strict";
/* ── Textes traduisibles : remplis par Liquid (locales/*.json > ldi18n.js_couette) ── */
var LDLOC = 'fr-FR';
var LDT = {
  k1: "1 oreiller",
  k2: "À l’unité",
  k3: "2 oreillers",
  k4: "Pack Duo",
  k5: "4 oreillers",
  k6: "Pack Famille",
  k7: "janv.",
  k8: "févr.",
  k9: "mars",
  k10: "avr.",
  k11: "mai",
  k12: "juin",
  k13: "juil.",
  k14: "août",
  k15: "sept.",
  k16: "oct.",
  k17: "nov.",
  k18: "déc.",
  k19: "1er",
  k20: "entre le {a} et le {b}",
  k21: ", dont {n} offert",
  k22: "Le + choisi",
  k23: "{n} oreillers offerts",
  k24: "{n} oreiller offert",
  k25: "{prix} \/ oreiller",
  k26: "Économisez {prix}",
  k27: "Votre panier",
  k28: "Fermer",
  k29: "Livraison",
  k30: "Passer au paiement",
  k31: "Garanties",
  k32: "Paiement sécurisé",
  k33: "100 nuits d’essai",
  k34: "Retour simple",
  k35: "Votre panier est vide.",
  k36: "Qté",
  k37: "Retirer",
  k38: "Livraison offerte débloquée",
  k39: "Plus que \u003cb\u003e{prix}\u003c\/b\u003e pour la livraison offerte",
  k40: "Offerte",
  k41: "Calculée au paiement",
  k42: "Estimée {date}",
  k43: "Ajout impossible",
  k44: "Acheter maintenant"
};
function ldf(s,o){ return String(s).replace(/\{(\w+)\}/g,function(m,k){ return Object.prototype.hasOwnProperty.call(o,k)?String(o[k]):m; }); }
  var root = document.getElementById("opb");
  if(!root) return;

  var DATA;
  try {
    DATA = JSON.parse(document.getElementById("opb-data").textContent);
  } catch(e) {
    return;
  }

  /* ===================== CONFIG RAPIDE ===================== */

  /* false = ajout panier + tiroir ; true = paiement direct */
  var DIRECT_CHECKOUT = false;

  /* 0 = pack 1 / 1 = pack 2 / 2 = pack 4 */
  var DEFAUT = 1;

  /* Seuil livraison offerte, en centimes */
  var SEUIL_LIVRAISON = 0;

  /* Délai affiché en jours ouvrés */
  var LIVRAISON = { min:5, max:7 };

  /*
    Remise additionnelle du bundle, EN CENTIMES.
    Laisse 0 tant qu'aucune réduction automatique Shopify correspondante
    n'est créée, sinon le prix affiché ici ne correspondra pas au checkout.

    Exemple si tu veux plus tard :
    2 oreillers = -10 €  => 2:1000
    4 oreillers = -30 €  => 4:3000
  */
  var REMISES = {
    1: 0,
    2: 0,
    4: 0
  };

  /*
    Oreillers OFFERTS par pack (unités non facturées).
    4:1  =>  pack de 4 = 3 payés + 1 offert.

    /!\ Nécessite une réduction automatique Shopify
    "Achetez 3, obtenez 1 gratuit" sur ce produit,
    sinon le checkout facturera les 4 oreillers.
  */
  var OFFERTS = {
    1: 0,
    2: 0,
    4: 0
  };

  /*
    Code de réduction appliqué automatiquement par pack.
    Le client n'a rien à taper : le bloc l'ajoute à l'URL de paiement.

    Crée le code dans Shopify > Réductions :
      PACK4  =>  -25 % sur l'oreiller (= 1 offert sur 4)
      (ou une réduction "Achetez 3, obtenez 1" avec ce même code)

    Laisse "" pour un pack sans réduction.
  */
  var CODES = {
    1: "",
    2: "",
    4: ""
  };

  var OFFRES = [
    { n:1, nom:LDT.k1,  pack:LDT.k2,  pop:false },
    { n:2, nom:LDT.k3, pack:LDT.k4,    pop:true  },
    { n:4, nom:LDT.k5, pack:LDT.k6,pop:false }
  ];

  /* =================== FIN CONFIG RAPIDE =================== */

  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR";
  var E = { off:DEFAUT, code:"" };

  /* le code choisi survit à un rechargement de page */
  try{
    E.code = sessionStorage.getItem("opb_code") || "";
  }catch(e){}

  function setCode(c){
    E.code = c || "";
    try{
      if(E.code) sessionStorage.setItem("opb_code",E.code);
      else sessionStorage.removeItem("opb_code");
    }catch(e){}
  }

  function shopRoot(){
    var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/";
    if(r.charAt(r.length-1)!=="/") r+="/";
    return r;
  }

  /* applique le code promo puis envoie vers le paiement */
  function checkoutUrl(){
    var r=shopRoot();
    if(E.code){
      return r+"discount/"+encodeURIComponent(E.code)+"?redirect="+encodeURIComponent(r+"checkout");
    }
    return r+"checkout";
  }

  function fmt(c){
    try{
      return new Intl.NumberFormat(LDLOC,{style:"currency",currency:CUR}).format(c/100);
    }catch(e){
      return (c/100).toFixed(2).replace(".",",")+" €";
    }
  }

  function fmt0(c){
    if(CUR==="EUR" && c%100===0) return (c/100)+"\u00a0€";
    return fmt(c);
  }

  function esc(s){
    return String(s==null?"":s).replace(/[&<>"]/g,function(m){
      return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[m];
    });
  }

  function offerts(n){
    return Math.max(0, OFFERTS[n] || 0);
  }

  function remise(n){
    return Math.max(0, (REMISES[n] || 0) + offerts(n) * DATA.price);
  }

  function total(of){
    return Math.max(0, DATA.price * of.n - remise(of.n));
  }

  function compareTotal(of){
    var base = (DATA.compare && DATA.compare > DATA.price) ? DATA.compare : DATA.price;
    return base * of.n;
  }

  function unitPrice(of){
    return Math.round(total(of) / of.n);
  }

  function economy(of){
    return Math.max(0, compareTotal(of) - total(of));
  }

  /* ---------- dates livraison ---------- */
  var MOIS=[LDT.k7,LDT.k8,LDT.k9,LDT.k10,LDT.k11,LDT.k12,LDT.k13,LDT.k14,LDT.k15,LDT.k16,LDT.k17,LDT.k18];

  function jourOuvre(n){
    var x=new Date();
    x.setHours(12,0,0,0);
    while(n>0){
      x.setDate(x.getDate()+1);
      var j=x.getDay();
      if(j!==0 && j!==6) n--;
    }
    return x;
  }

  function jourTxt(x,mois){
    var d=x.getDate();
    return (d===1?LDT.k19:d)+(mois?" "+MOIS[x.getMonth()]:"");
  }

  function livraisonTexte(){
    var a=jourOuvre(LIVRAISON.min), b=jourOuvre(LIVRAISON.max);
    return ldf(LDT.k20,{a:jourTxt(a,a.getMonth()!==b.getMonth()),b:jourTxt(b,true)});
  }

  /* ---------- rendu bundle ---------- */
  function renderBundle(){
    var box=root.querySelector(".opb-offres");
    box.innerHTML="";

    OFFRES.forEach(function(of,i){
      var sel=i===E.off;
      var t=total(of);
      var b=compareTotal(of);
      var eco=economy(of);
      var off=offerts(of.n);

      var card=document.createElement("button");
      card.type="button";
      card.className="opb-card"+(sel?" on":"")+(of.pop?" pop":"");
      card.setAttribute("role","radio");
      card.setAttribute("aria-checked",sel?"true":"false");
      card.setAttribute("aria-label",
        of.nom+(off>0?ldf(LDT.k21,{n:off}):"")+" — "+fmt(t));

      card.innerHTML=
        (of.pop?'<span class="opb-tag">'+LDT.k22+'</span>':"")+
        '<span class="opb-check" aria-hidden="true"></span>'+
        '<span class="opb-name">'+esc(of.nom)+'</span>'+
        '<span class="opb-pack">'+esc(of.pack)+'</span>'+
        (off>0
          ? '<span class="opb-free">'+
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+
                '<path d="M20 12v9H4v-9M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>'+
              '</svg>'+
              '<b>'+ldf(off>1?LDT.k23:LDT.k24,{n:off})+'</b>'+
            '</span>'
          : '<span class="opb-free ghost">&nbsp;</span>')+
        '<span class="opb-total">'+fmt(t)+'</span>'+
        (b>t?'<s class="opb-strike">'+fmt(b)+'</s>':'<span class="opb-strike ghost">&nbsp;</span>')+
        '<span class="opb-unit">'+ldf(LDT.k25,{prix:fmt(unitPrice(of))})+'</span>'+
        (eco>0?'<span class="opb-save">'+ldf(LDT.k26,{prix:fmt0(eco)})+'</span>':'<span class="opb-save ghost">&nbsp;</span>');

      card.addEventListener("click",function(){
        E.off=i;
        renderBundle();
      });

      box.appendChild(card);
    });
  }

  /* ---------- panier latéral ---------- */
  var DW=null;

  function buildDrawer(){
    if(DW) return DW;

    var d=document.createElement("div");
    d.className="opb-dw";
    d.hidden=true;

    d.innerHTML=
      '<div class="opb-dw-ov" data-close></div>'+
      '<aside class="opb-dw-p" role="dialog" aria-modal="true" aria-label="'+esc(LDT.k27)+'">'+
        '<header class="opb-dw-h">'+
          '<span class="opb-dw-title">'+LDT.k27+'</span>'+
          '<button type="button" class="opb-dw-x" data-close aria-label="'+esc(LDT.k28)+'">'+
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>'+
          '</button>'+
        '</header>'+
        '<div class="opb-dw-prog" data-prog></div>'+
        '<div class="opb-dw-b" data-lines></div>'+
        '<footer class="opb-dw-f">'+
          '<div class="opb-dw-terms" data-terms>'+
            '<div class="opb-dw-row"><span>'+LDT.k29+'<small data-ship-est></small></span><b data-ship></b></div>'+
          '</div>'+
          '<button type="button" class="opb-dw-go" data-checkout>'+
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+
              '<rect x="4" y="10.5" width="16" height="11" rx="2.5"/><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5"/>'+
            '</svg>'+
            '<span>'+LDT.k30+'</span>'+
            '<i></i>'+
            '<b data-cart-total></b>'+
          '</button>'+
          '<ul class="opb-dw-rea" aria-label="'+esc(LDT.k31)+'">'+
            '<li>'+LDT.k32+'</li>'+
            '<li>'+LDT.k33+'</li>'+
            '<li>'+LDT.k34+'</li>'+
          '</ul>'+
        '</footer>'+
      '</aside>';

    document.body.appendChild(d);

    d.querySelectorAll("[data-close]").forEach(function(el){
      el.addEventListener("click",closeDrawer);
    });

    d.querySelector("[data-checkout]").addEventListener("click",function(){
      this.disabled=true;
      window.location.href=checkoutUrl();
    });

    document.addEventListener("keydown",function(e){
      if(e.key==="Escape" && DW && !DW.hidden) closeDrawer();
    });

    DW=d;
    return d;
  }

  function closeDrawer(){
    if(!DW) return;
    DW.hidden=true;
    document.documentElement.style.overflow="";
  }

  function renderCart(cart){
    var d=buildDrawer();
    var lines=d.querySelector("[data-lines]");
    lines.innerHTML="";

    if(!cart.items || !cart.items.length){
      lines.innerHTML='<p class="opb-dw-empty">'+LDT.k35+'</p>';
      d.querySelector("[data-prog]").innerHTML="";
      d.querySelector("[data-terms]").style.display="none";
      d.querySelector("[data-cart-total]").textContent="";
    }else{
      cart.items.forEach(function(it){
        var row=document.createElement("div");
        row.className="opb-dw-l";

        var src=it.image||"";
        var img=src ? src.replace(/(\.[a-z]+)(\?|$)/i,"_240x240_crop_center$1$2") : "";
        var sub=(it.variant_title && it.variant_title!=="Default Title") ? it.variant_title : "";

        row.innerHTML=
          (img?'<img src="'+esc(img)+'" alt="" loading="lazy">':'<span class="opb-dw-ph"></span>')+
          '<div class="opb-dw-info">'+
            '<p class="opb-dw-name">'+esc(it.product_title)+'</p>'+
            (sub?'<p class="opb-dw-var">'+esc(sub)+'</p>':'')+
            '<span class="opb-dw-q">'+LDT.k36+' <b>'+it.quantity+'</b></span>'+
          '</div>'+
          '<div class="opb-dw-price">'+
            (it.original_line_price>it.final_line_price?'<s>'+fmt(it.original_line_price)+'</s>':'')+
            '<b>'+fmt(it.final_line_price!=null?it.final_line_price:it.line_price)+'</b>'+
          '</div>'+
          '<button type="button" class="opb-dw-del" aria-label="'+esc(LDT.k37)+'">'+
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>'+
          '</button>';

        row.querySelector(".opb-dw-del").addEventListener("click",function(){
          this.disabled=true;
          row.classList.add("busy");

          fetch("/cart/change.js",{
            method:"POST",
            headers:{"Content-Type":"application/json","Accept":"application/json"},
            body:JSON.stringify({id:it.key,quantity:0})
          })
          .then(function(r){ return r.json(); })
          .then(renderCart)
          .catch(function(){ row.classList.remove("busy"); });
        });

        lines.appendChild(row);
      });

      var tp=cart.total_price||0;
      var reste=Math.max(0,SEUIL_LIVRAISON-tp);
      var okShip=reste<=0;

      d.querySelector("[data-prog]").innerHTML=
        (okShip
          ? '<p class="opb-dw-pmsg ok">✓ '+LDT.k38+'</p>'
          : '<p class="opb-dw-pmsg">'+ldf(LDT.k39,{prix:fmt(reste)})+'</p>')+
        '<div class="opb-dw-track"><span class="opb-dw-fill'+(okShip?' done':'')+'" style="width:'+
          Math.round(Math.min(1,tp/SEUIL_LIVRAISON)*100)+'%"></span></div>';

      d.querySelector("[data-terms]").style.display="";
      var sh=d.querySelector("[data-ship]");
      sh.textContent=okShip?LDT.k40:LDT.k41;
      sh.className=okShip?"ok":"";
      d.querySelector("[data-ship-est]").textContent=ldf(LDT.k42,{date:livraisonTexte()});
      d.querySelector("[data-cart-total]").textContent=fmt(tp);
    }

    d.hidden=false;
    document.documentElement.style.overflow="hidden";
  }

  /* ---------- ajout au panier : UNIQUEMENT L'OREILLER ---------- */
  var cta=root.querySelector(".opb-cta");
  if (!DATA.available) {
    cta.disabled = true;
    cta.querySelector('[data-cta-label]').textContent = 'Vérification de la disponibilité…';
    fetch(window.location.pathname + '.js', {headers:{Accept:'application/json'}})
      .then(function(r){if(!r.ok)throw new Error('availability');return r.json();})
      .then(function(p){var v=p.variants.find(function(v){return String(v.id)===String(DATA.id);});
        DATA.available=!!(v&&v.available);cta.disabled=!DATA.available;
        cta.querySelector('[data-cta-label]').textContent=DATA.available?'Ajouter au panier':'Indisponible';
      }).catch(function(){cta.querySelector('[data-cta-label]').textContent='Indisponible';});
  }


  cta.addEventListener("click",function(){
    if(!DATA.available) return;

    var btn=this;
    var msg=root.querySelector(".opb-msg");
    var of=OFFRES[E.off];

    msg.textContent="";
    msg.className="opb-msg";
    btn.disabled=true;
    btn.classList.add("load");

    /*
      IMPORTANT :
      Il n'y a volontairement QU'UN SEUL item envoyé :
      la variante de l'oreiller, avec la quantité TOTALE du pack
      (offerts inclus : pack 4 => quantity 4).
      C'est la réduction automatique Shopify qui déduit l'oreiller offert.
      Aucune taie n'est ajoutée ici.
    */
    var items=[{
      id:parseInt(DATA.id,10),
      quantity:of.n
    }];

    /* code promo correspondant au pack choisi */
    setCode(CODES[of.n]);

    fetch("/cart/add.js",{
      method:"POST",
      headers:{"Content-Type":"application/json","Accept":"application/json"},
      body:JSON.stringify({items:items})
    })
    .then(function(r){
      return r.json().then(function(d){ return {ok:r.ok,d:d}; });
    })
    .then(function(r){
      if(!r.ok) throw new Error(r.d.description||LDT.k43);
      return fetch("/cart.js");
    })
    .then(function(r){ return r.json(); })
    .then(function(cart){
      if(DIRECT_CHECKOUT){
        window.location.href=checkoutUrl();
        return;
      }

      btn.disabled=false;
      btn.classList.remove("load");
      renderCart(cart);
    })
    .catch(function(e){
      btn.disabled=false;
      btn.classList.remove("load");
      msg.textContent=e.message||LDT.k43;
      msg.className="opb-msg err";
    });
  });

  /* ---------- l'icône panier du thème ouvre ce tiroir ---------- */
  (function(){
    var css=document.createElement("style");
    css.textContent="cart-drawer,#CartDrawer,#CartDrawer-Overlay{display:none!important}";
    document.head.appendChild(css);

    function patch(){
      var CD=window.customElements&&customElements.get("cart-drawer");
      if(!CD || CD.prototype.__opb) return;
      CD.prototype.__opb=true;

      CD.prototype.open=function(){
        this.classList.remove("active","animate");
        document.body.classList.remove("overflow-hidden");
        fetch("/cart.js").then(function(r){return r.json();}).then(renderCart)
          .catch(function(){window.location.href="/cart";});
      };

      CD.prototype.close=function(){
        this.classList.remove("active","animate");
        document.body.classList.remove("overflow-hidden");
      };
    }

    patch();
    document.addEventListener("DOMContentLoaded",patch);
    window.addEventListener("load",patch);
    document.addEventListener("shopify:section:load",patch);
  })();

  function isCartTrigger(el){
    if(!el || !el.getAttribute) return false;

    var id=el.id||"";
    if(/cart-icon|cart-bubble|cart-drawer-toggle/i.test(id)) return true;

    var ac=el.getAttribute("aria-controls")||"";
    if(ac.toLowerCase().indexOf("cart")!==-1) return true;

    var href=el.getAttribute("href");
    if(href){
      var p=href.split("?")[0].split("#")[0];
      if(/\/cart\/?$/.test(p)) return true;
    }

    var cl=el.className;
    cl=(cl&&cl.baseVal!==undefined)?cl.baseVal:(cl||"");
    return /cart-icon|cart-link|cart-toggle|cart-count|header__icon--cart|js-cart-open|site-header__cart/i.test(String(cl));
  }

  document.addEventListener("click",function(e){
    if(DW && DW.contains(e.target)) return;
    if(root.contains(e.target)) return;

    var n=e.target,hit=null;
    while(n && n!==document){
      if(isCartTrigger(n)){ hit=n; break; }
      n=n.parentNode;
    }

    if(!hit) return;

    e.preventDefault();
    e.stopPropagation();

    fetch("/cart.js")
      .then(function(r){return r.json();})
      .then(renderCart)
      .catch(function(){window.location.href="/cart";});
  },true);

  var shipEl=root.querySelector("[data-opb-ship]");
  if(shipEl) shipEl.textContent=livraisonTexte();

  if(DIRECT_CHECKOUT){
    var lbl=root.querySelector("[data-cta-label]");
    if(lbl) lbl.textContent=LDT.k44;
  }

  window.LDOreillerCart={
    open:function(){
      fetch("/cart.js").then(function(r){return r.json();}).then(renderCart)
        .catch(function(){window.location.href="/cart";});
    },
    render:renderCart,
    close:closeDrawer
  };

  renderBundle();
})();
